import * as React from 'react';
import { isArray } from 'lodash';
import Alert, { AlertVariant } from '@lendi-ui/alert';

import { errorBoxError } from '@funnels/types';

export interface ErrorAlertProps {
  errorHeading?: string;
  errorBody?: string | errorBoxError[];
  errorContent?: React.ReactNode;
  variant?: AlertVariant;
  withoutErrorName?: boolean;
}

function getBodyTextList(errorBody: errorBoxError[], withoutErrorName?: boolean) {
  const apiNameList = errorBody.map(({ name, message = '' }) => (
    <li key={`${name}-${message.replace(/ /g, '-')}`}>{`${!withoutErrorName ? `${name}: ` : ''}${message}`}</li>
  ));
  return <ul>{apiNameList}</ul>;
}

export function ErrorAlert(props: ErrorAlertProps) {
  const { errorHeading, errorBody, errorContent, variant = 'error', withoutErrorName } = props;
  const defaultErrorHeading = 'Service failed. If the problem persists, create a helpdesk ticket.';

  const headingText = errorHeading ?? defaultErrorHeading;
  const bodyText = !errorBody
    ? errorContent
    : isArray(errorBody)
    ? getBodyTextList(errorBody, withoutErrorName)
    : errorBody;

  return (
    <Alert variant={variant} heading={headingText}>
      {bodyText}
    </Alert>
  );
}
